var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPnk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.221 4 14.08.63L30 17.31 21.958 28.9l-14.155-.908L2 14.252 10.22 4zm10.323 7.31L10.34 15.772l8.723 6.753 1.48-11.217zm-1.181-2.237-8.154-3.516-1.713 7.391 9.867-3.875zm-2.067 15.152L8.433 17.89l.214 8.585 8.648-2.25zm11.29-6.942-6.04-6.136-1.593 11.798 7.632-5.662zm-9.212 8.322-7.474 1.956 8.788.565-1.315-2.52zm8.031-5.539-6.542 4.88 1.3 2.544 5.242-7.424zM24.31 6.402l-1.27 2.612 4.729 4.814-3.46-7.426zm-1.583-1.25-8.306-.338 6.852 3 1.455-2.662zM9.007 6.36l-5.817 7.355 3.89.825 1.928-8.18zm-2.162 9.623-3.908-.829 4.078 9.62-.17-8.791z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPnk);
export default __webpack_public_path__ + "static/media/PNK.8e86d1e2221f969413df6f167d826943.svg";
export { ForwardRef as ReactComponent };